import Model, { attr } from '@ember-data/model';

export default class SerpResultKnowledgePanel extends Model {
  @attr('string') cid;
  @attr('string') title;
  @attr('string') url;
}
